// extracted by mini-css-extract-plugin
module.exports = {"title":"featured-demo-preview-module--title--LY5AX","image":"featured-demo-preview-module--image--3ST23","container":"featured-demo-preview-module--container--uJ5XW"};